import React from 'react'
import Rating from '@mui/material/Rating';
import { Link } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import { useEffect } from 'react';
import CheckLogin from '../../actions/LoginStatus';
import { useState } from 'react';
import RedirectNext from '../../actions/RedirectNext';
import LoginStatus from '../../actions/LoginStatus';
import PriceFormat from '../../actions/PriceFormat';
import img from '../../assets/images/course/course.jpg'
const CourseItem = ({ course, slider, index, useronline }) => {
  const [loggedin, setloggedin] = useState(LoginStatus())
  const [newimage, setnewimage] = useState(useronline ? course.course_cover_url : img)

  useEffect(() => {
    setnewimage(useronline ? course.course_cover_url : img)
  }, [useronline])
  console.log("user is :" + useronline)
  //console.log("login status is "+LoginStatus())
  return (
    <Link to={
      course.mode === "internship"
        ? "/internship/" + course.course_url + "/" + course.mode
        : "/course/" + course.course_url + "/" + course.mode
    } 
    className={slider ? "col-lg-4 col-md-4 col-sm-6 col-12  col-md-3 col-sm-4 col-12 p-3 slider-course-container fade-in-bottom " + "delay" + index + "s" : "col-lg-4 col-md-4 col-sm-6 col-12 course-container col-md-3 col-sm-4 col-12 p-3 fade-in-bottom " + "delay" + index + "s"}>

      {/* <div className="course-content rounded">
        <img src={newimage} className="course-cover" />

        <div className="info">
          <h5 className="title course-title truncate truncate2">{course.course_title}</h5>

          <div className="d-flex mt-2 align-items-center">
            <Rating
              name="simple-controlled"
              value={course.rating}
              readOnly
              className='clr-siloconMinds-orng'

            />
            <p className="pb-0 mb-0 sm-14">({course.course_students})</p>
          </div>
          {course.mode === "free" ?
            <>
              <div className="d-flex justify-content-between">

                <p className="text-orangered course-price">Free  </p>

              </div>
            </> :
            <>
              <div className="d-flex">
                <p className="text-orangered course-price mr-15">{PriceFormat(course.course_price)}  </p>
                <s className="mb-0 mt-1 text-dark">{PriceFormat(course.course_cutoff_price)}</s>
              </div>

            </>}



        </div>



        <div className="d-none d-sm-flex buttons-holder p-2">
          <button className="btn">{course.seats_left} Seats left</button>
          <vr />
          <button className="btn btn-siloconMinds-orng text-light py-1 px-2">Sign Up</button>
        </div>

      </div> */}

      <div key={index} className="mb-3">
      <Link
  to={
    course.mode === "internship"
      ? "/internship/" + course.course_url + "/" + course.mode
      : "/course/" + course.course_url + "/" + course.mode
  }
  className="text-decoration-none"
>
          <div className="ly-card">
            {/* IMAGE */}
            <div
              className="ly-img"
              style={{ "--bg": `url(${course.course_cover_url || img})` }}
            >
              <img
                src={course.course_cover_url || img}
                alt={course.course_title}
              />

              <span className={`ly-badge ${course.mode === "live" ? "live" : "self"}`}>
                {course.mode}
              </span>
            </div>
            {/* BODY */}
            <div className="ly-body">
              <div className='d-flex'>
                <Rating className='clr-siliconMinds-orng' value={course.rating} readOnly size="small" /><p className="pb-0 mb-0 sm-14">({course.course_students})</p>
              </div>
              <h5 className="ly-title">{course.course_title}</h5>

              <p className="ly-enrolled">
                {course.course_students} Enrolled
              </p>

              <div className="ly-price-row">
                {/* <span className="ly-price">
                  {PriceFormat(course.course_price)}
                </span>
                <del>{PriceFormat(course.course_cutoff_price)}</del> */}
                <span className="ly-seats">
                  {course.seats_left} seats left
                </span>
              </div>

              <button className="ly-btn">🎓 View More</button>
            </div>
          </div>
        </Link>
      </div>
    </Link>
  )
}

export default CourseItem